export enum AttachmentKind {
    General,
    EmailToSupplierAttachment,
    ExpenseReportLineAttachment,
}
